import formatRupiah from "../../utils/FormatRupiah";
import formatTanggal from "../../utils/FormatTanggal";

const columns = [
  {
    title: "Tanggal",
    dataIndex: "tgl",
    key: "tgl",
    render: (text) => <p>{formatTanggal(text)}</p>,
  },
  {
    title: "No. Akun",
    dataIndex: "noAcc",
    key: "noAcc",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Nama Akun",
    dataIndex: "nameAcc",
    key: "nameAcc",
  },
  {
    title: "Keterangan",
    dataIndex: "keterangan",
    key: "keterangan",
  },
  {
    title: "DEBET",
    dataIndex: "amount",
    key: "amount",
    render: (text, payload) => (
      <p>{payload.kategori == "debit" ? formatRupiah(text) : "-"}</p>
    ),
  },
  {
    title: "KREDIT",
    dataIndex: "amount",
    key: "amount",
    render: (text, payload) => (
      <p>{payload.kategori == "kredit" ? formatRupiah(text) : "-"}</p>
    ),
  },
];

const formValidation = [
  [
    {
      title: "No. Akun",
      key: "noAcc",
      placeholder: "Masukan No. Akun",
      type: "text",
      required: true,
      validationText: "nomor akun harus diisi!",
    },
    {
      title: "Nama Akun",
      key: "nameAcc",
      placeholder: "Masukan Nama Akun",
      type: "text",
      required: true,
      validationText: "nama akun harus diisi!",
    },
  ],
  {
    title: "Tanggal Masuk",
    key: "tgl",
    placeholder: "Masukan tanggal masuk Anggota",
    type: "dateTime",
    required: true,
    validationText: "tanggal masuk harus diisi!",
  },
  {
    title: "Keterangan",
    key: "keterangan",
    placeholder: "Masukan Keterangan",
    type: "textarea",
    required: true,
    validationText: "alamat harus diisi!",
  },
  [
    {
      title: "Debet",
      key: "debet",
      placeholder: "Masukan Debet",
      type: "number",
      required: true,
      validationText: "Debet harus diisi!",
    },
    {
      title: "Kredit",
      key: "kredit",
      placeholder: "Masukan Kredit",
      type: "number",
      required: true,
      validationText: "Kredit harus diisi!",
    },
  ],
];

export { columns, formValidation };
